<template>
  <validation-observer ref="observer" v-slot="{ invalid }">
    <v-container class="h-full flex justify-center items-center px-8">
      <div v-if="displayMode != null" class="flex flex-col">
        <v-row class="my-3"></v-row>

        <!-- 氏名 -->
        <v-row class="items-center">
          <v-col cols="12" sm="4" class="py-1 py-sm-3">
            <span class="text-gray-600">氏名</span
            ><span v-if="!readonly" class="ml-1 red--text">*</span>
          </v-col>

          <!-- 姓 -->
          <v-col cols="6" sm="4" class="py-1 py-sm-3 flex-auto">
            <validation-provider v-slot="{ errors }" name="姓" rules="required|max:10">
              <v-text-field
                v-model="patient.lastName"
                placeholder="姓"
                outlined
                dense
                :error-messages="errors"
                :disabled="readonly"
              >
              </v-text-field>
            </validation-provider>
          </v-col>

          <!-- 名 -->
          <v-col cols="6" sm="4" class="py-1 py-sm-3 flex-auto">
            <validation-provider v-slot="{ errors }" name="名" rules="required|max:10">
              <v-text-field
                v-model="patient.firstName"
                placeholder="名"
                outlined
                dense
                :error-messages="errors"
                :disabled="readonly"
              >
              </v-text-field>
            </validation-provider>
          </v-col>
        </v-row>

        <v-row class="my-0"></v-row>

        <!-- 氏名(かな) -->
        <v-row class="items-center">
          <v-col cols="12" sm="4" class="py-1 py-sm-3">
            <span class="text-gray-600">氏名（かな）</span
            ><span v-if="!readonly" class="ml-1 red--text">*</span>
          </v-col>

          <!-- せい -->
          <v-col cols="6" sm="4" class="py-1 py-sm-3 flex-auto">
            <validation-provider v-slot="{ errors }" name="せい" rules="required|hiragana|max:20">
              <v-text-field
                v-model="patient.lastNameKana"
                placeholder="せい"
                outlined
                dense
                :error-messages="errors"
                :disabled="readonly"
              >
              </v-text-field>
            </validation-provider>
          </v-col>

          <!-- めい -->
          <v-col cols="6" sm="4" class="py-1 py-sm-3 flex-auto">
            <validation-provider v-slot="{ errors }" name="めい" rules="required|hiragana|max:20">
              <v-text-field
                v-model="patient.firstNameKana"
                placeholder="めい"
                outlined
                dense
                :error-messages="errors"
                :disabled="readonly"
              >
              </v-text-field>
            </validation-provider>
          </v-col>
        </v-row>

        <v-row class="my-0"></v-row>

        <!-- 性別 -->
        <v-row class="items-center">
          <v-col cols="12" sm="4" class="py-1 py-sm-3">
            <span class="text-gray-600">性別</span
            ><span v-if="!readonly" class="ml-1 red--text">*</span>
          </v-col>
          <v-col cols="12" sm="8" class="py-1 py-sm-3">
            <validation-provider v-slot="{ errors }" name="性別" rules="required">
              <v-text-field
                v-if="readonly"
                :value="GENDER_LABEL[patient.gender]"
                dense
                outlined
                disabled
                hide-details="auto"
              >
              </v-text-field>

              <v-radio-group
                v-else
                class="mt-0"
                v-model="patient.gender"
                row
                :error-messages="errors"
                hide-details="auto"
              >
                <v-radio
                  v-for="gender in GENDERS"
                  :key="gender.value"
                  :label="gender.label"
                  :value="gender.value"
                >
                </v-radio>
              </v-radio-group>
            </validation-provider>
          </v-col>
        </v-row>

        <v-row class="my-3"></v-row>

        <!-- 生年月日 -->
        <v-row class="items-center">
          <v-col cols="12" sm="4" class="py-1 py-sm-3">
            <span class="text-gray-600">生年月日</span
            ><span v-if="!readonly" class="ml-1 red--text">*</span>
          </v-col>
          <v-col cols="12" sm="8" class="py-1 py-sm-3">
            <DateOfBirthPicker v-model="selectedDate" :readonly="readonly" />
          </v-col>
        </v-row>

        <v-row class="my-3"></v-row>

        <!-- 住所 -->
        <v-row class="items-center">
          <v-col cols="12" class="py-1 font-bold"><span class="text-gray-600">住所</span></v-col>

          <!-- 住所詳細 -->
          <v-col cols="12">
            <!-- 郵便番号 -->
            <v-row class="items-center">
              <v-col cols="12" sm="5" class="py-1 py-sm-3"
                ><span class="text-gray-600">郵便番号（ハイフンなし）</span></v-col
              >
              <v-col cols="12" sm="7" class="py-1 py-sm-3">
                <validation-provider v-slot="{ errors }" name="郵便番号" rules="digits:7">
                  <v-text-field
                    v-model="patient.postCode"
                    outlined
                    dense
                    :error-messages="errors"
                    hide-details="auto"
                    :disabled="readonly"
                  >
                  </v-text-field>
                </validation-provider>
              </v-col>
            </v-row>

            <!-- 都道府県 -->
            <v-row class="items-center">
              <v-col cols="12" sm="5" class="py-1 py-sm-3"
                ><span class="text-gray-600">都道府県</span></v-col
              >
              <v-col cols="12" sm="7" class="py-1 py-sm-3">
                <validation-provider v-slot="{ errors }" name="都道府県" rules="">
                  <v-text-field
                    v-if="readonly"
                    :value="PREFECTURE_LABEL[patient.prefectureCode]"
                    dense
                    outlined
                    disabled
                    hide-details="auto"
                  >
                  </v-text-field>
                  <v-select
                    v-else
                    v-model="patient.prefectureCode"
                    :items="PREFECTURES"
                    item-value="value"
                    item-text="label"
                    outlined
                    dense
                    :error-messages="errors"
                    hide-details="auto"
                  >
                  </v-select>
                </validation-provider>
              </v-col>
            </v-row>

            <!-- 市区町村 -->
            <v-row class="items-center">
              <v-col cols="12" sm="5" class="py-1 py-sm-3"
                ><span class="text-gray-600">市区町村</span></v-col
              >
              <v-col cols="12" sm="7" class="py-1 py-sm-3">
                <validation-provider v-slot="{ errors }" name="市区町村" rules="max:30">
                  <v-text-field
                    v-model="patient.municipality"
                    outlined
                    dense
                    :error-messages="errors"
                    hide-details="auto"
                    :disabled="readonly"
                  >
                  </v-text-field>
                </validation-provider>
              </v-col>
            </v-row>

            <!-- 番地 -->
            <v-row class="items-center">
              <v-col cols="12" sm="5" class="py-1 py-sm-3"
                ><span class="text-gray-600">番地</span></v-col
              >
              <v-col cols="12" sm="7" class="py-1 py-sm-3">
                <validation-provider v-slot="{ errors }" name="番地" rules="max:20">
                  <v-text-field
                    v-model="patient.addressNumber"
                    outlined
                    dense
                    :error-messages="errors"
                    hide-details="auto"
                    :disabled="readonly"
                  >
                  </v-text-field>
                </validation-provider>
              </v-col>
            </v-row>

            <!-- 建物名・部屋番号 -->
            <v-row class="items-center">
              <v-col cols="12" sm="5" class="py-1 py-sm-3"
                ><span class="text-gray-600">建物名・部屋番号</span></v-col
              >
              <v-col cols="12" sm="7" class="py-1 py-sm-3">
                <validation-provider v-slot="{ errors }" name="建物名・部屋番号" rules="max:50">
                  <v-text-field
                    v-model="patient.buildingNameAndRoomNumber"
                    outlined
                    dense
                    :error-messages="errors"
                    hide-details="auto"
                    :disabled="readonly"
                  >
                  </v-text-field>
                </validation-provider>
              </v-col>
            </v-row>
          </v-col>
        </v-row>

        <v-row class="my-3"></v-row>

        <!-- 連絡先 -->
        <v-row class="items-center">
          <v-col cols="12" class="py-1 font-bold"><span class="text-gray-600">連絡先</span></v-col>

          <!-- 連絡先詳細 -->
          <v-col cols="12">
            <!-- メールアドレス -->
            <v-row class="items-center">
              <v-col cols="12" sm="5" class="py-1 py-sm-3">
                <span class="text-gray-600">メールアドレス</span
                ><span v-if="displayMode == DISPLAY_MODE.REGISTER" class="ml-1 red--text">*</span>
              </v-col>
              <v-col cols="12" sm="7" class="py-1 py-sm-3">
                <validation-provider
                  v-slot="{ errors }"
                  name="メールアドレス"
                  rules="required|email"
                >
                  <v-text-field
                    v-model="patient.email"
                    type="email"
                    outlined
                    dense
                    :error-messages="errors"
                    hide-details="auto"
                    :disabled="displayMode != DISPLAY_MODE.REGISTER"
                  >
                  </v-text-field>
                </validation-provider>
              </v-col>
            </v-row>

            <!-- 電話番号 -->
            <v-row class="items-center">
              <v-col cols="12" sm="5" class="py-1 py-sm-3">
                <span class="text-gray-600">電話番号（ハイフンなし）</span
                ><span v-if="!readonly" class="ml-1 red--text">*</span>
              </v-col>
              <v-col cols="12" sm="7" class="py-1 py-sm-3">
                <validation-provider
                  v-slot="{ errors }"
                  name="電話番号"
                  rules="required|numeric|max:11"
                >
                  <v-text-field
                    v-model="patient.phoneNumber"
                    type="tel"
                    outlined
                    dense
                    :error-messages="errors"
                    hide-details="auto"
                    :disabled="readonly"
                  >
                  </v-text-field>
                </validation-provider>
              </v-col>
            </v-row>
          </v-col>
        </v-row>

        <v-row class="my-3"></v-row>

        <v-row v-if="displayMode == DISPLAY_MODE.REGISTER" class="items-center">
          <v-col cols="12">
            <!-- パスワード -->
            <v-row class="items-center">
              <v-col cols="12" sm="5" class="py-1 py-sm-3">
                <span class="text-gray-600">パスワード</span><span class="ml-1 red--text">*</span>
                <v-tooltip right>
                  <template v-slot:activator="{ on, attrs }">
                    <v-icon v-bind="attrs" v-on="on"> mdi-help-circle-outline </v-icon>
                  </template>
                  <div>
                    パスワードは以下を満たす必要があります
                    <ul class="list-disc">
                      <li>{{ PASSWORD_MIN_LENGTH }}文字以上</li>
                      <li>英字・数字・記号を含む</li>
                      <li>使用可能な記号{{ PASSWORD_ENABLE_SYMBOLS }}</li>
                    </ul>
                  </div>
                </v-tooltip>
              </v-col>
              <v-col cols="12" sm="7" class="py-1 py-sm-3">
                <validation-provider
                  v-slot="{ errors }"
                  name="パスワード"
                  rules="required|password"
                >
                  <v-text-field
                    v-model="patient.password"
                    :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
                    :type="showPassword ? 'text' : 'password'"
                    dense
                    autoComplete="new-password"
                    solo
                    flat
                    outlined
                    :error-messages="errors"
                    @click:append="showPassword = !showPassword"
                    hide-details="auto"
                  >
                  </v-text-field>
                </validation-provider>
              </v-col>
            </v-row>

            <!-- パスワード（確認用） -->
            <v-row class="items-center">
              <v-col cols="12" sm="5" class="py-1 py-sm-3">
                <span class="text-gray-600">パスワード（確認用）</span
                ><span class="ml-1 red--text">*</span>
              </v-col>
              <v-col cols="12" sm="7" class="py-1 py-sm-3">
                <validation-provider
                  v-slot="{ errors }"
                  name="パスワード（確認用）"
                  :rules="`required|password|password_confirm:${patient.password}`"
                >
                  <v-text-field
                    v-model="patient.passwordConfirm"
                    :append-icon="showPasswordConfirm ? 'mdi-eye' : 'mdi-eye-off'"
                    :type="showPasswordConfirm ? 'text' : 'password'"
                    dense
                    outlined
                    :error-messages="errors"
                    @click:append="showPasswordConfirm = !showPasswordConfirm"
                    hide-details="auto"
                  >
                  </v-text-field>
                </validation-provider>
              </v-col>
            </v-row>
          </v-col>
        </v-row>

        <v-row class="my-4"></v-row>

        <!-- 登録ボタン -->
        <v-btn
          v-if="displayMode == DISPLAY_MODE.REGISTER"
          elevation=""
          color="primary"
          :disabled="invalid || isProcessing"
          @click="registerPatient"
          class="mb-4"
        >
          登録
        </v-btn>

        <!-- ログイン画面に戻る -->
        <v-btn
          v-if="displayMode == DISPLAY_MODE.REGISTER"
          color="grey"
          outlined
          block
          @click="$router.push('/').catch(() => {})"
        >
          ログイン画面に戻る
        </v-btn>

        <div class="sticky" style="bottom: calc(67px + env(safe-area-inset-bottom))">
          <!-- 編集ボタン -->
          <v-btn
            v-show="displayMode == DISPLAY_MODE.DETAIL"
            color="primary"
            x-large
            block
            elevation="0"
            @click="showEdit"
          >
            <v-icon>mdi-pencil</v-icon>
            編集
          </v-btn>

          <!-- キャンセル -->
          <v-row v-show="displayMode == DISPLAY_MODE.UPDATE" justify="space-between">
            <v-col cols="6">
              <v-btn color="grey" x-large block dark elevation="0" @click="showDetail">
                キャンセル
              </v-btn>
            </v-col>

            <!-- 保存ボタン -->
            <v-col cols="6">
              <v-btn
                color="primary"
                x-large
                block
                elevation="0"
                :disabled="invalid || isProcessing"
                @click="update"
              >
                <v-icon>mdi-check</v-icon>
                保存
              </v-btn>
            </v-col>
          </v-row>
        </div>
      </div>
    </v-container>
  </validation-observer>
</template>

<script>
import DateOfBirthPicker from "@/components/molecules/DateOfBirthPicker";
import {
  DISPLAY_MODE,
  GENDER,
  GENDERS,
  GENDER_LABEL,
  PASSWORD_ENABLE_SYMBOLS,
  PASSWORD_MIN_LENGTH,
  PREFECTURES,
  PREFECTURE_LABEL,
} from "@/const/const";
import { MESSAGES } from "@/const/message";
import commonMixin from "@/mixins/commonMixin";
import errorHandlerMixin from "@/mixins/errorHandlerMixin";

import {
  Timestamp,
  collection,
  doc,
  getDocs,
  query,
  runTransaction,
  serverTimestamp,
  where,
} from "firebase/firestore";
import moment from "moment";
import { mapActions, mapState } from "vuex";

export default {
  name: "EditPatient",
  components: {
    DateOfBirthPicker,
  },
  mixins: [commonMixin(), errorHandlerMixin()],
  data: () => ({
    // 病院リスト
    hospitals: [],
    // 患者情報
    patient: {
      // 病院ID
      hospitalIds: [],
      // 姓
      lastName: "",
      // 名
      firstName: "",
      // 姓(かな)
      lastNameKana: "",
      // 名(かな)
      firstNameKana: "",
      // 性別
      gender: GENDER.UNSELECTED,
      // 生年月日
      dateOfBirth: "",
      // 郵便番号
      postCode: "",
      // 都道府県
      prefectureCode: "",
      // 市区町村
      municipality: "",
      // 番地
      addressNumber: "",
      // 建物名・部屋番号
      buildingNameAndRoomNumber: "",
      // メールアドレス
      email: "",
      // 電話番号
      phoneNumber: "",
      // パスワード
      password: "",
      // パスワード（確認用）
      passwordConfirm: "",
      // 担当医
      doctorUids: [],
      // メンバー
      memberUids: [],
      // 病気
      diseases: [],
      // 薬
      medications: [],
      // 備考
      note: "",
    },
    // チャットグループ ID
    patientChatGroupIds: [],
    // 選択された日付
    selectedDate: "",
    // パスワード使用可能記号
    PASSWORD_ENABLE_SYMBOLS,
    // パスワード最小文字数
    PASSWORD_MIN_LENGTH,
    // 性別
    GENDERS,
    // 性別のラベル
    GENDER_LABEL,
    // 都道府県情報
    PREFECTURES,
    // 都道府県のラベル
    PREFECTURE_LABEL,
    // パスワード表示制御
    showPassword: false,
    showPasswordConfirm: false,
    // 処理中フラグ
    isProcessing: false,
    // 画面表示モード
    displayMode: null,
    DISPLAY_MODE,
  }),
  computed: {
    // ログインユーザー
    ...mapState("user", ["selfUser"]),
    // 読み取り専用か
    readonly() {
      return this.displayMode == DISPLAY_MODE.DETAIL;
    },
  },
  watch: {
    // リロード時などはログインユーザーの取得処理がcreatedでは間に合わないため、取得されたタイミングで患者情報をセットする。
    selfUser(user) {
      if (user?.uid) {
        this.displayMode = DISPLAY_MODE.DETAIL;
        // 患者情報をセット
        this.setPatientData();
      }
    },
    displayMode(newVal) {
      if (newVal !== null) {
        this.$nextTick(() => {
          // autocomplete を無効化する
          this.disableAutocomplete();
        });
      }
    },
  },
  async created() {
    // 病院の選択肢を取得
    await this.getHospitals();

    // 都道府県の選択肢に、空白を追加
    PREFECTURES.unshift({ value: "", label: "" });

    // ログインユーザー情報があれば患者情報としてセット
    if (this.selfUser?.uid) {
      this.displayMode = DISPLAY_MODE.DETAIL;
      // 患者情報をセット
      this.setPatientData();
    } else {
      this.displayMode = DISPLAY_MODE.REGISTER;
    }
  },
  methods: {
    ...mapActions("api", ["incrementRunningApiCount", "decrementRunningApiCount"]),

    // 詳細画面を表示
    showDetail() {
      this.patient = { ...this.selfUser };
      this.displayMode = DISPLAY_MODE.DETAIL;
    },

    // 編集画面を表示
    showEdit() {
      this.displayMode = DISPLAY_MODE.UPDATE;
    },

    // 病院マスタ読み込み
    async getHospitals() {
      try {
        this.incrementRunningApiCount();
        const func = this.$httpsCallable(this.$functions, "gethospitallist");
        const res = await func();
        this.hospitals = res.data.map(({ id, name }) => ({ id, name }));

        this.decrementRunningApiCount();

        // 病院リストの先頭を初期値として設定
        this.patient.hospitalIds = [];
        this.patient.hospitalIds.push(this.hospitals[0].id);
      } catch (err) {
        this.showError(MESSAGES.ERRORS.UNEXPECTED);
      }
    },
    // 患者情報をログイン情報からセット
    setPatientData() {
      this.patient = { ...this.selfUser };
      // v-selectに初期表示で都道府県を表示するためNumberに変換
      this.patient.prefectureCode = Number(this.patient.prefectureCode);
      // timestamp型をカレンダーに対応する形式に変換
      this.$nextTick(() => {
        this.selectedDate = moment(this.patient.dateOfBirth?.toDate()).format("YYYY-MM-DD");
      });
      // 患者のchatGroupsIdを取得
      this.getPatientChatGroupIds();
    },
    // 患者のチャットグループIDを取得
    async getPatientChatGroupIds() {
      try {
        const q = query(
          collection(this.$firestore, "chatGroups"),
          where("patientUid", "==", this.patient.uid)
        );

        const querySnapshot = await getDocs(q);

        // TODO: 複数のチャットグループに所属する場合はチャットグループ一覧を表示する
        this.patientChatGroupIds.push(querySnapshot.docs[0].id);
      } catch {
        this.showError(MESSAGES.ERRORS.UNEXPECTED);
      }
    },
    // 登録
    async registerPatient() {
      try {
        this.isProcessing = true;
        this.incrementRunningApiCount();

        // 生年月日は this.patient とバインドされていないため、画面の選択値をセットしなおす。
        this.patient.dateOfBirth = this.selectedDate;

        // 患者を追加
        const registerPatientFunction = this.$httpsCallable(this.$functions, "registerpatient");
        await registerPatientFunction({ userMode: true, ...this.patient });

        this.$store.dispatch("snackbar/openSnackbar", {
          text: `登録しました`,
          color: "success",
        });

        this.$router.push("/").catch(() => {});
      } catch (error) {
        if (error.message === "auth/already-exists") {
          this.showError("メールアドレスが登録済みです");
        } else if (error.message === "auth/invalid-password") {
          this.showError("パスワードの形式が不正です");
        } else {
          this.showError(`登録に失敗しました。\nしばらく経ってからもう一度お試しください。`);
        }
      } finally {
        this.decrementRunningApiCount();
        this.isProcessing = false;
      }
    },
    // 更新
    async update() {
      try {
        this.isProcessing = true;
        this.incrementRunningApiCount();

        // 患者情報
        const {
          uid,
          hospitalIds,
          lastName,
          firstName,
          lastNameKana,
          firstNameKana,
          gender,
          postCode,
          prefectureCode,
          municipality,
          addressNumber,
          buildingNameAndRoomNumber,
          phoneNumber,
        } = this.patient;

        let { dateOfBirth } = this.patient;

        // 選択された日付をTimestampのsecondsに変換
        const birthDay = new Date(`${this.selectedDate}T00:00:00Z`);
        dateOfBirth = Timestamp.fromDate(birthDay);

        const db = this.$firestore;

        await runTransaction(db, async (transaction) => {
          const patientDocRef = doc(db, "users", uid);
          const chatGroupDocRef = doc(db, "chatGroups", this.patientChatGroupIds[0]);

          await transaction.get(patientDocRef);
          await transaction.get(chatGroupDocRef);

          // 患者情報を更新
          await transaction.update(patientDocRef, {
            hospitalIds,
            lastName,
            firstName,
            lastNameKana,
            firstNameKana,
            gender,
            dateOfBirth,
            postCode,
            prefectureCode,
            municipality,
            addressNumber,
            buildingNameAndRoomNumber,
            phoneNumber,
            updatedUserId: this.selfUser.uid,
            updated: serverTimestamp(),
          });

          // チャットグループ名を更新
          await transaction.update(chatGroupDocRef, {
            name: `${this.patient.lastName} ${this.patient.firstName}`,
            updatedUserId: this.selfUser.uid,
            updated: serverTimestamp(),
          });
        });

        this.$store.dispatch("snackbar/openSnackbar", {
          text: `保存しました`,
          color: "success",
        });

        this.showDetail();
      } catch (error) {
        this.showError(`保存に失敗しました。\nしばらく経ってからもう一度お試しください。`);
      } finally {
        this.decrementRunningApiCount();
        this.isProcessing = false;
      }
    },
  },
};
</script>
<style scoped>
.theme--light.v-btn.v-btn--disabled {
  background-color: #e0e0e0 !important;
}
</style>
